import { HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HANDLED_ERROR_STATUSES, TABLE_DEFAULT_HANDLED_STATUSES } from "src/app/common/table/table-resource";
import { HttpService } from "src/app/services/http.service";
import { environment } from "src/environments/environment";
import { DepartmentInfo, SyncOverviewDto } from "./dashboard.model";
import { TimelineEventDto } from "src/app/features/events/events.models";

@Injectable()
export class DashboardService {
    constructor(
        private http: HttpService,
    ) { }

    private async getTimeline(config: 'Config' | 'Sync', departmentId: string, take: number, days: number): Promise<TimelineEventDto[]> {
        // App Insights kan fejle uafhængigt af resten af dashboardet (fx manglende Azure-credential);
        // kaldene viser selv en fejltilstand, så den globale 500-redirect til /error springes over.
        const options = { ...this.http.options(), context: new HttpContext().set(HANDLED_ERROR_STATUSES, TABLE_DEFAULT_HANDLED_STATUSES) };
        return await this.http.get<TimelineEventDto[]>(`${environment.adminConfig.apiUri}/timeline/query/${config}/${departmentId}?take=${take}&days=${days}`, null, options);
    }

    async getCustomerCount(departmentguid: string): Promise<number> {
        return await this.http.get<number>(`${environment.adminConfig.apiUri}/dashboard/customercount/${departmentguid}`);
    }

    async getCompanyCount(departmentguid: string): Promise<number> {
        return await this.http.get<number>(`${environment.adminConfig.apiUri}/dashboard/companycount/${departmentguid}`);
    }

    async getSynchronizationCount(departmentguid: string): Promise<number> {
        return await this.http.get<number>(`${environment.adminConfig.apiUri}/dashboard/synchronizationcount/${departmentguid}`);
    }

    async getUniqueResourceAccesses(departmentguid: string): Promise<DepartmentInfo[]> {
        return await this.http.get<DepartmentInfo[]>(`${environment.adminConfig.apiUri}/dashboard/resourceAccesses/${departmentguid}`);
    }

    async getSyncErrorCount(): Promise<number> {
        return await this.http.get<number>(`${environment.adminConfig.apiUri}/dashboard/sync-error-count`);
    }

    async getChangelogs(departmentId: string, take: number = 10, days: number = 30): Promise<TimelineEventDto[]> {
        return await this.getTimeline('Config', departmentId, take, days);
    }

    async getRecentSyncs(departmentId: string): Promise<SyncOverviewDto[]> {
        return await this.http.get<SyncOverviewDto[]>(`${environment.adminConfig.apiUri}/dashboard/recent-syncs/${departmentId}`);
    }
}

